// CourseCard.js
import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

import "./Courses.css";

const CourseCard = ({ course }) => {
  return (
    <div className="side-content col-xl-4 col-lg-6 col-md-4 col-sm-6 mb-5 courses_sectionn">
      <Link to={`/course-details/${course.id}`}>
        <Fade direction="up" delay={200}>
          <div className="card courses_section_card">
            <div className="coursesCard -type-1">
              <div className="relative">
                <div className="coursesCard__image overflow-hidden rounded-8 position-relative">
                  <img
                    src={course.image}
                    alt="card-image"
                    className="w-1\/1 zoom-image"
                    style={{ height: "200px" }}
                  />
                  <div className="coursesCard__image_overlay rounded-8"></div>
                </div>
                <div className="d-flex justify-between py-10 px-10 absolute-full-center z-3"></div>
              </div>

              <div className="h-100 pt-15">
                <div className="d-flex items-center">
                  <div className="text-14 lh-1 text-yellow-1 mr-10">
                    {course.rating}
                  </div>
                  <div className="d-flex x-gap-5 items-center">
                    <div className="icon-star text-9 text-yellow-1 ">
                      <i class="ri-star-fill"></i>
                    </div>
                    <div className="icon-star text-9 text-yellow-1 ">
                      <i class="ri-star-fill"></i>
                    </div>
                    <div className="icon-star text-9 text-yellow-1 ">
                      <i class="ri-star-fill"></i>
                    </div>
                    <div className="icon-star text-9 text-yellow-1 ">
                      <i class="ri-star-line"></i>
                    </div>
                    <div className="icon-star text-9 text-yellow-1 ">
                      <i class="ri-star-line"></i>
                    </div>
                  </div>
                  <div className="text-13 lh-1 ml-10 " >({course.reviews})</div>
                </div>
                <div className="text-17 lh-15 fw-500 text-dark-1 mt-10">
                  <Link className="linkCustom course_title" >{course.title}</Link>
                </div>
                {/* <div className="d-flex x-gap-10 items-center pt-10">
                <div className="d-flex items-center mr-5">
                  <div className="mr-8">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/coursesCards/icons/1.svg"
                      className=""
                      alt="icon"
                    />
                  </div>
                  <div className="text-14 lh-1">{course.lessons} Lessons</div>
                </div>
                <div className="d-flex items-center mr-5">
                  <div className="mr-8">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/coursesCards/icons/2.svg"
                      className=""
                      alt="icon"
                    />
                  </div>
                  <div className="text-14 lh-1">{course.duration}</div>
                </div>
                <div className="d-flex items-center">
                  <div className="mr-8">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/coursesCards/icons/3.svg"
                      className=""
                      alt="icon"
                    />
                  </div>
                  <div className="text-14 lh-1">{course.level}</div>
                </div>
              </div> */}
                <div className="d-flex lessio mt-3">
                  <p><span><i class="ri-todo-line"></i></span>{course.lessons} Lessons</p>
                  <p><span><i class="ri-history-line"></i></span>{course.duration}</p>
                  <p><span><i class="ri-stairs-line"></i></span>{course.level}</p>
                </div>
                <div className="coursesCard-footer">
                  <div className="coursesCard-footer__author">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/general/avatar-1.png"
                      alt="author-avtar"
                    />
                    <div>{course.author}</div>
                  </div>
                  {/* <div className="coursesCard-footer__price">
                    <div>{course.originalPrice}</div>
                    <div>{course.discountedPrice}</div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </Fade>

        <div className="side-content__item">
          <div className="px-30 pt-20 pb-30 bg-white rounded-8 border-light shadow-2">
            <div className="text-18 lh-16 text-dark-1 course_title">{course.title}</div>

            <div className="d-flex lessio mt-3">
              <p><span><i class="ri-todo-line"></i></span>{course.lessons} Lessons</p>
              <p><span><i class="ri-history-line"></i></span>{course.duration}</p>
              <p><span><i class="ri-stairs-line"></i></span>{course.level}</p>
            </div>

            <div className=" best_seller mt-0">
              Best Seller
            </div>

            <p className="mt-3 course_description">{course.description}</p>
            <div className="row  course_features">
              {course.features.map((feature) => (
                <div className="col-12">
                  {/* <div className="d-flex items-center">
                  <div className="size-20 d-flex items-center justify-center rounded-full border-light">
                    <div className="icon-check text-6">
                      <i class="ri-check-double-line"></i>
                    </div>
                  </div>
                  <div className="ml-10">{feature}</div>
                </div> */}
                  <ul>
                    <li><span> <i class="ri-check-double-line"></i></span>{feature}</li>
                  </ul>
                </div>
              ))}
            </div>

            {/* <div className="row x-gap-20 y-gap-15 items-center">
              <div className="col">
                <button
                  className="course_cart_btn"

                >
                  Add To Cart
                </button>
              </div>
              <div className="col-auto">
                <div className="d-flex items-center justify-center size-60 rounded-full border-light">
                  <div className="icon-bookmark text-20 text-purple-1">
                    <i class="ri-bookmark-line"></i>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CourseCard;
